// extracted by mini-css-extract-plugin
module.exports = {"footer":"_3SwKJ","button":"WvcJs","wrap":"rhmyW"};